export const keyCodes = {
  enter: 13,
  space: 32,
  escape: 27,
  tab: 9,
};
